'use client';

import {
  ProductGalleryNextControl,
  ProductGalleryVariant,
} from '@vs-shop/commerce-ui/productGallery';
import { useIntl } from 'react-intl';

type Props = {
  onNext: () => void;
  disabled?: boolean;
};

/** rcprofi's step on through the gallery's media. */
export default function GalleryNextStandaloneButton({ onNext, disabled = false }: Props) {
  const intl = useIntl();

  return (
    <ProductGalleryNextControl
      variant={ProductGalleryVariant.INLINE}
      disabled={disabled}
      onClick={onNext}
      aria-label={intl.formatMessage({
        id: 'component.server.page.product.gallery.galleryModalNextButton.next',
        defaultMessage: 'Další',
      })}
    >
      <span className="sr-only">
        {intl.formatMessage({
          id: 'component.client.page.product.gallery.galleryNextStandaloneButton.next',
          defaultMessage: 'Následující obrázek',
        })}
      </span>
    </ProductGalleryNextControl>
  );
}
